// extracted by mini-css-extract-plugin
export default {"container":"AddNoteInline-module--container--cvDtZ","button-label":"AddNoteInline-module--button-label--xMpw1"};